import { ContentType } from '../models/ContentType';
import { SearchResultList, SearchResultItem } from '../models/SearchResultTypes';

export interface SingleContentTypeState {
  contentType?: ContentType;
  searchResults?: SearchResultList<SearchResultItem>;
  initialDataFullyLoaded?: boolean;
}

export const initialState: SingleContentTypeState = {};
